import React from 'react';

export type AtableLogoVariant = 'wordmark' | 'lockup';

export interface AtableLogoProps {
    /**
     * `wordmark` — juste "atable" (sans tagline). Utilisé quand le contexte
     *              fournit déjà un sous-titre / tagline séparé (ex: Sidebar).
     * `lockup`   — wordmark + "Chaque repas compte" intégré. Utilisé pour les
     *              écrans hero / splash / auth où le logo est central.
     */
    variant?: AtableLogoVariant;
    /** Hauteur du logo en CSS units. Largeur auto pour préserver l'aspect. */
    height?: number | string;
    className?: string;
    /** Alt text pour accessibilité — défaut "atable" */
    alt?: string;
}

const SRC: Record<AtableLogoVariant, string> = {
    wordmark: '/brand/atable-wordmark.png',
    lockup:   '/brand/atable-lockup.png',
};

export const AtableLogo: React.FC<AtableLogoProps> = ({
    variant = 'wordmark',
    height,
    className = '',
    alt = 'atable',
}) => {
    const style = height !== undefined ? { height: typeof height === 'number' ? `${height}px` : height } : undefined;
    return (
        <img
            src={SRC[variant]}
            alt={alt}
            className={`select-none ${className}`}
            style={style}
            draggable={false}
        />
    );
};

export default AtableLogo;
